import api from './api'

export interface AuditLog {
  id: number
  action: 'create' | 'update' | 'delete' | 'reverse' | 'cycling'
  model_name: string
  object_id: number
  user: number
  user_detail?: {
    id: number
    username: string
    email: string
  }
  data_before: Record<string, any> | null
  data_after: Record<string, any> | null
  description: string
  timestamp: string
}

export const auditService = {
  /**
   * Get all audit logs
   */
  async getAll(params?: {
    action?: string
    model_name?: string
    user?: number
    ordering?: string
  }): Promise<AuditLog[]> {
    const response = await api.get<AuditLog[]>('/audit-logs/', { params })
    return response.data
  },

  /**
   * Get audit log by ID
   */
  async getById(id: number): Promise<AuditLog> {
    const response = await api.get<AuditLog>(`/audit-logs/${id}/`)
    return response.data
  },
}

export default auditService
